/**
 * UserDashboardPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, ExpandableContainer } from 'components';
import {
  Divider,
  Button,
  Table,
  Radio,
  Spin,
  Statistic,
  Tooltip as AntTooltip,
} from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  ExportOutlined,
  QuestionCircleTwoTone,
} from '@ant-design/icons';
import {
  CartesianGrid,
  Tooltip,
  BarChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Legend,
  Bar,
  Rectangle,
} from 'recharts';
import { stringToMoneyFormat } from 'utils';

/**----------------------------------------
 * [Component] 총관리자: 주문대시보드 - 프레젠터
 * ----------------------------------------
 */
const UserDashboardPresenter = ({
  loading,
  chartData,
  statisticsType,
  setStatisticsType,
  handleGetCartList,

  //
  userStatics,
  gradeStatics,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */

  /* ===== VARIABLE ===== */
  const formItem = [
    {
      label: '기간설정',
      form: [
        {
          input: (
            <>
              <Radio.Group
                size="large"
                defaultValue="month"
                buttonStyle="solid"
                value={statisticsType}
                onChange={(e) => setStatisticsType(e.target.value)}
                style={{ marginRight: 12 }}
              >
                <Radio.Button value="today">오늘</Radio.Button>
                <Radio.Button value="week">1주일(7일)</Radio.Button>
                <Radio.Button value="month">1개월(30일)</Radio.Button>
                <Radio.Button value="3month">3개월(90일)</Radio.Button>
              </Radio.Group>
            </>
          ),
        },
      ],
    },
  ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */

  /*  */
  /* 상품별 데이터 */
  const productChart = chartData?.product
    ? Object.keys(chartData.product).map((item) => ({
        name: chartData.product[item].label,
        value: chartData.product[item].data.length,
        ...chartData.product[item],
      }))
    : [];

  /* ===== RENDER ===== */
  console.log('userStatics: ', userStatics);

  // JSX: start
  return (
    <Spin spinning={loading}>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title size={3} style={{ marginBottom: 12 }}>
              회원 현황
            </Title>

            {/* === 현황 요약: start === */}
            <Content
              fullWidth
              padding={0}
              backgroundColor={'none'}
              style={{
                marginBottom: 5,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {[
                {
                  title: '가입자 수',
                  value: stringToMoneyFormat(
                    Number(userStatics?.user_count ?? 0)
                  ),
                  suffix: '명',
                },
                {
                  title: (
                    <AntTooltip title="15일 이내 가입한 유저">
                      <span>신규유저</span> <QuestionCircleTwoTone />
                    </AntTooltip>
                  ),
                  value: stringToMoneyFormat(
                    Number(userStatics?.new_user_count ?? 0)
                  ),
                  suffix: '명',
                },
                {
                  title: 'JM페이 회원',
                  value: stringToMoneyFormat(
                    Number(userStatics?.jmpay_user_count ?? 0)
                  ),
                  suffix: '명',
                },
                {
                  title: '휴면고객',
                  value: stringToMoneyFormat(
                    Number(userStatics?.dormant_user_count ?? 0)
                  ),
                  suffix: '명',
                },
                {
                  title: '탈퇴/정지회원',
                  value: stringToMoneyFormat(
                    Number(userStatics?.withdrawn_user_count ?? 0)
                  ),
                  suffix: '명',
                },
              ].map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  className="boxShadow"
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `90%`,
                    margin: '0 2px',
                    padding: 24,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Statistic
                    className="cursorOverOpacity"
                    direction={'row'}
                    size="large"
                    title={_item.title}
                    value={_item.value}
                    suffix={_item.suffix}
                    // style={{ justifyContent: 'center' }}
                    valueStyle={{
                      color: '#1677ff',
                      textDecoration: 'underline !important',
                    }}
                  />
                  {/* <div>
                    <Button shape="circle">
                      <ExportOutlined />
                    </Button>
                  </div> */}
                </div>
              ))}
            </Content>
            {/* === 현황 요약: end === */}

            {/* ===== 차트: start ===== */}
            <Row gutter={[5, 5]}>
              {/* === 상품별: start === */}
              <Col x={16}>
                <Content
                  maxWidth={'100%'}
                  borderRadius={4}
                  // padding={'14px 5px'}
                  height={420}
                >
                  <Title size={5} style={{ marginBottom: 12 }}>
                    등급
                  </Title>
                  <Divider style={{ margin: 0 }} />
                  <ResponsiveContainer
                    width="100%"
                    height={320}
                    style={{ marginTop: 25 }}
                  >
                    <BarChart
                      width={500}
                      // height={300}
                      data={
                        gradeStatics
                          ? gradeStatics.map((i) => ({
                              ...i,
                              ['인원']: i.user_count,
                            }))
                          : []
                      }
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="grade_name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <Bar
                        dataKey="인원"
                        fill="#82ca9d"
                        activeBar={<Rectangle fill="gold" stroke="purple" />}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </Content>
              </Col>
              {/* === 상품별: end === */}

              {/* === 내역: start === */}
              <Col x={8}>
                <Content
                  maxWidth={'100%'}
                  height={420}
                  borderRadius={4}
                  // padding={'14px 5px'}
                >
                  <Title size={5} style={{ marginBottom: 12 }}>
                    등급별
                  </Title>

                  <Table
                    bordered
                    size="small"
                    scroll={{ y: 450 }}
                    pagination={false}
                    dataSource={gradeStatics ?? []}
                    columns={[
                      {
                        title: '등급명',
                        dataIndex: 'grade_name',
                        // width: 150,
                        align: 'center',
                      },
                      {
                        title: '인원',
                        dataIndex: 'user_count',
                        width: 150,
                        align: 'center',
                        render: (value) =>
                          `${stringToMoneyFormat(Number(value))}명`,
                      },
                    ]}
                  />
                </Content>
              </Col>
              {/* === 내역: end === */}
            </Row>
            {/* ===== 차트: end ===== */}
          </Col>

          <Col x={24}>
            {/* <br /> */}
            <Button
              block
              size="large"
              style={{ marginTop: 5 }}
              onClick={() => window.open('/users/list', '_blank')}
            >
              유저목록 바로가기 <ExportOutlined />
            </Button>
          </Col>
        </Row>
      </Content>
    </Spin>
  ); // JSX: end
};

export default UserDashboardPresenter;
